import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useCampfireTheme } from '../../../../../../theme/useCampfireTheme';
import { TaskFieldTypeEnum } from '../../../../admin-console/admin-console-content-pages/admin-console-volunteer-profile/admin-console-volunteer-profile-model';
import { FieldIcon } from '../../../../admin-console/admin-console-content-pages/admin-console-volunteer-profile/form-builder/dialogs/field-task-item-dialog/FieldIcon';

interface FieldFormItemTitleProps {
  __typename: TaskFieldTypeEnum;
  optional: boolean;
  name: string;
}

export const FieldFormItemTitle = ({ __typename, optional, name }: FieldFormItemTitleProps) => {
  const { theme } = useCampfireTheme();
  return (
    <Grid item container spacing={1} xs alignItems='center'>
      <Grid item>
        <FieldIcon fieldType={__typename} style={{ color: `${theme.palette.text.secondary}` }} fontSize='small' />
      </Grid>
      <Grid item container xs>
        <Typography display='inline' style={{ fontWeight: 'bold' }}>
          {name}
          {!optional ? <span style={{ color: theme.status.red.dark, marginLeft: 2 }}>{'*'}</span> : null}
        </Typography>
      </Grid>
    </Grid>
  );
};
